import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api,API_URL} from '../../actions/_request';
import swal from 'sweetalert2';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';


import * as actions from '../../actions/balancegeneral';


import ReactTable from "react-table";
import "react-table/react-table.css";

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,InputGroupText,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';

import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';
import Fasearch from 'react-icons/lib/fa/search';
import FAprint from 'react-icons/lib/fa/print';
const {PropTypes} = React;

const CustomTooltip  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      // console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill,'fontSize':'21px' }} >{`${item.name} : ${new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.value)}`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});

const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

class BalanceGeneral extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			data : {
				lista:[],
				costo:'$0.00',
				meta:'$140,000.00',
				servicios:'$0.00',
				ventas:'$0.00',
				utilidad_ventas:'$0.00',
				utilidad_mes:'$0.00',
				grafica:[],
			},
			 calis:[{ name:'mes', Utilidad: 29443.87, Meta: 140000}],
			 activeTab: '1',
			 buscar:0,
       tickets:[],
       mostrar_lista:false,
			
		}
		
		this.toggle_tab= this.toggle_tab.bind(this);
		this.handleSelectChange= this.handleSelectChange.bind(this);
		this.search= this.search.bind(this);
    this.lista_tickets= this.lista_tickets.bind(this);
		
	}

  lista_tickets(){
    let self = this;
        api().get(`/tickets_distribucion_participaciones/${this.state.mes}/${this.state.ano}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                       // console.log('response--------->',response.data)
                self.setState({
                  tickets : response.data,
                  mostrar_lista:true,

                });
                }

            });
  }


	handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
           
             
                [name]: value,
                buscar:0,
        
        });
    }
	search(){
		let self = this;
		    api().get(`/distribucion_participaciones/${this.state.mes}/${this.state.ano}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                
                     
                       // console.log('response--------->',response.data)
                       self.setState({
				        	data : response.data,
				        	buscar:1,

				        });
                }

            });
	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }
	 componentDidMount(){
	  let self = this;

	 	var fecha = new Date();
        var ano = fecha.getFullYear();
        let anos=[];

        for (var i = 5 ; i >= 0; i--) {
        	anos.unshift({label:(ano-i),value:(ano-i)});
        }



        this.setState({
        	mes : parseInt(fecha.getMonth())+1,
        	ano:ano,
        	anos:anos,
        });

         api().get(`/distribucion_participaciones/${parseInt(fecha.getMonth())+1}/${ano}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                
                     
                       // console.log('response--------->',response.data)
                       self.setState({
				        	data : response.data,
				        	buscar:1,

				        });
                }

            });
       
        
        
    }

      formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}









	render(){

		let {mes,ano,data} = this.state;
		// console.log("state--->",this.state);

		let fecha_actual= new Date();

		let fecha_comprar= new Date(`${fecha_actual.getFullYear()}-${parseInt(fecha_actual.getMonth())+1}-01`);

		let fecha_reporte= new Date(`${ano}-${mes}-01`);

		let candado=true;
		if(fecha_comprar < fecha_reporte || (parseInt(fecha_comprar.getMonth())+1==mes&& fecha_comprar.getFullYear()==ano ) )
			candado=false;



		let user= 0;//parseInt(this.props.user.user,10);
		let rol=0;

		
        if (typeof(this.props.auth.user) !="undefined")
        {           
            user= parseInt(this.props.auth.user.id);
            rol= parseInt(this.props.auth.user.rol);
            // console.log('usuario----->',this.props.auth.user)
       }
		
		// console.log('fecha_reporte---->',fecha_reporte);


		return(
		<Card className="px-3">
			<div className="mb-2"></div>
			<Nav tabs>
				<NavItem>
					<NavLink className={classnames({ active: this.state.activeTab === '1' })}	onClick={() => { this.toggle_tab('1'); }}	>
						Distribucion de participaciones
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent activeTab={this.state.activeTab}>
				<TabPane tabId="1">
				 <div className="row mt-3">
				<div className="col-md-4"> 
                    <div className="form-group">
                        <label >Mes:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="mes"
                            options={meses}
                            value={parseInt(this.state.mes) || 1}
                           onChange={ (select) => { this.handleSelectChange(select, 'mes') } }
                           disabled ={rol!=4?true:false}
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-4"> 
                    <div className="form-group">
                        <label >Año:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="ano"
                            options={this.state.anos}
                            value={parseInt(this.state.ano) || 1}
                           onChange={ (select) => { this.handleSelectChange(select, 'ano') } }
                            disabled ={rol!=4?true:false}
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-4"> 
                    <div className="form-group">
                    					<label><br/></label><br/>
										<Button color='success' onClick={this.search}> <Fasearch/> </Button>	
                    </div>


                 </div>

                </div>
                	
					<Row className='mt-3'>
					<div className="col-md-12"> 
						<div className="form-group">
							<label > <b>Meta:</b> {data.meta}</label>
						</div>
					</div>
					<div className="col-md-12"> 
						<div className="form-group">
							<label > <b>Total Servicios:</b> {data.servicios} </label>
						</div>
					</div>
					<div className="col-md-12">  
						<div className="form-group">
							<label > <b>Total Ventas:</b> {data.ventas} </label><label className='ml-3'> <b> Costo de lo Vendido:</b> {data.costo}</label><label className='ml-3'> <b>Utilidad de la Venta:</b> {data.utilidad_ventas} </label>
						</div>
					</div>
					
					<div className="col-md-12"> 
						<div className="form-group">
							<label > <b>Total Producción: </b> {data.utilida_mes_grafica} </label><label className='ml-3' > <b>Porcentaje: </b> {data.porcentaje} </label><label className='ml-3' > <b>Utilidad Total del Mes: </b> {data.utilidad_mes} </label>
						</div>
					</div>
					</Row>
					
					{ (user==15||user==9||user==1)&&
					<Row className='mt-3'>
					<div className="col-md-2"></div>
					<div className="col-md-8">
					<ReactTable
                              data      = {data.lista}
                              className = "-striped -highlight"
                              columns   = {[
                                {filterable: false,sortable: false,Header: 'Personal', accessor: 'nombre'},
                                {filterable: false,sortable: false,Header: '% Part.', accessor: 'porcentaje',maxWidth:150, style: { 'textAlign': 'center'}},
                                {filterable: false,sortable: false,Header: 'Importe', accessor: 'importe',maxWidth:150 , style: { 'textAlign': 'center'}},  
                                {filterable: false,sortable: false,Header: '-10% Imp.', accessor: 'impuesto',maxWidth:150 , style: { 'textAlign': 'center'}},
                                {filterable: false,sortable: false,Header: 'Total', accessor: 'total',maxWidth:150 , style: { 'textAlign': 'center'}},                             
                              ]}
                              filterable 
                              defaultPageSize={10} 
 
                              
                              
                            />
                    </div>
					</Row>
				    }

					<Row className='mt-3'>
					<div className="col-md-2"></div>
					<div className="col-md-8">
					<div style={{width: '100%', height: '400px'}}>
					<ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data.grafica}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
								  {
                                    (Object.keys(this.state.data.grafica).length === 0 )?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip/>}/>
                                  }
                                  <Legend />
                                  <Bar dataKey='Utilidad' fill='#406CBF' minPointSize={1} />
                                  <Bar dataKey="Meta" fill='green' minPointSize={1} />
                          
                                </BarChart>
                    </ResponsiveContainer>
                    </div>
                    </div>
					</Row>
                  <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row justify-content-end">
                       
                        <div className="col-5  text-right" >
                          <div className="form-group">
                            <label><br/></label><br/>
                            <Button color='success' onClick={this.lista_tickets}> Mostrar Lista </Button>
                          </div>
                        </div>
                          
                        </div>
                            <ReactTable
                              data      = {this.state.tickets}
                              className = "-striped -highlight"
                              columns   = {[
                               {Header: 'Fecha', accessor: 'fecha_finalizado',maxWidth:180,minWidth:180 , style: { 'textAlign': 'left'}},
                                {Header: 'Tecnico', accessor: 'asignado',maxWidth:150},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},       
                                {Header: 'Subtotal', accessor: 'subtotal',maxWidth:180,minWidth:180 , style: { 'textAlign': 'center'}}                      
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={filterCaseInsensitive}
                              
                               SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                 <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Costo Total</th>  
                                                  <th>Producción</th>                                            
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>  
                                                     <td>{this.formateo(item.subtotal)}</td> 
                                                     <td>{this.formateo(item.costo_total)}</td>
                                                     <td>{this.formateo(item.produccion)}</td>
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

   
					<br/>
					<br/>
					<br/>
					<br/>

				</TabPane>
			</TabContent>
		</Card>
		)
	}

}

function mapStateToProps(state, ownProps) {
    return {
        balancegeneral : state.balancegeneral,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(BalanceGeneral)


// WEBPACK FOOTER //
// ./src/views/reportes/DistribucionParticipaciones.js